import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/npv-calculator',
  component: () => import('../../routes/NPVCalculator.svelte'),
  card: {
    id: 'npv-calculator',
    title: 'NPV Calculator',
    description: 'Calculate Net Present Value to evaluate investments and projects using discounted cash flow analysis. Determine if an investment creates or destroys value.',
    icon: 'account_balance_wallet',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/npv-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'NPV Calculator – Net Present Value Calculator',
    description: 'Free NPV calculator to evaluate investments and projects using discounted cash flow analysis. Calculate Net Present Value, IRR, and view year-by-year breakdowns to determine if an investment creates value.',
  },
};

export default meta;
